"use client";
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import { jsxs as m, jsx as f } from "react/jsx-runtime";
import * as e from "react";
import { isWebViewBridgeAvailable as C } from "@tef-novum/webview-bridge";
const k = /*#__PURE__*/ e.createContext({
    snackbars: [],
    setSnackbars: ()=>{}
}), p = /*#__PURE__*/ e.lazy(()=>import(/* webpackChunkName: "snackbar" */ "./snackbar.js")), R = (param)=>{
    let { children: l } = param;
    const [t, n] = e.useState([]), o = e.useRef(null), a = e.useRef(!1), r = C();
    e.useEffect(()=>{
        var c;
        t.length > 1 && !a.current && (a.current = !0, r ? n((i)=>i.slice(1)) : (c = o.current) == null || c.close({
            action: "CONSECUTIVE"
        }));
    }, [
        t,
        r
    ]);
    const d = (param)=>{
        let { action: c } = param;
        var i, b;
        a.current = !1, n(r && c === "CONSECUTIVE" ? (u)=>u.slice(0) : (u)=>u.slice(1)), (b = (i = t[0]).onClose) == null || b.call(i, {
            action: c
        });
    }, S = e.useMemo(()=>({
            snackbars: t,
            setSnackbars: n
        }), [
        t
    ]), s = t[0];
    return /* @__PURE__ */ m(k.Provider, {
        value: S,
        children: [
            l,
            !!s && /* @__PURE__ */ f(e.Suspense, {
                fallback: null,
                children: /* @__PURE__ */ f(p, {
                    ref: o,
                    message: s.message,
                    buttonText: s.buttonText,
                    buttonAccessibilityLabel: s.buttonAccessibilityLabel,
                    duration: s.duration,
                    type: s.type,
                    withDismiss: s.withDismiss,
                    dataAttributes: s.dataAttributes,
                    onClose: d
                }, s.id)
            })
        ]
    });
}, g = ()=>{
    const { snackbars: l, setSnackbars: t } = e.useContext(k);
    return {
        openSnackbar: e.useCallback((o)=>{
            const a = Date.now() + "-" + Math.random();
            t((r)=>[
                    ...r,
                    _object_spread_props(_object_spread({}, o), {
                        id: a
                    })
                ]);
        }, [
            t
        ]),
        snackbars: l
    };
};
export { R as SnackbarRoot, g as useSnackbar };
